import { alpha, makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  error: {
    color: theme.palette.error.main,
  },
  errorBg: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: alpha(theme.palette.error.main, 0.7),
    },
  },
  filterCard: {
    marginBottom: theme.spacing(2),
  },
  footerSeparator: {
    backgroundColor: theme.palette.secondary.main,
    padding: '2px',
  },
  primary: {
    color: theme.palette.primary.main,
  },
  primaryBg: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.7),
    },
  },
  secondary: {
    color: theme.palette.secondary.main,
  },
  secondaryBg: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: alpha(theme.palette.secondary.main, 0.7),
    },
  },
  success: {
    color: theme.palette.success.main,
  },
  successBg: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.success.main,
    '&:hover': {
      backgroundColor: alpha(theme.palette.success.main, 0.7),
    },
  },
  scrollMobile: {
    overflowX: 'auto',
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch', // iOS
    touchAction: 'auto',              // permite gestos touch
    maxWidth: '100%',
    '&::-webkit-scrollbar': {
      height: 8,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#ccc',
      borderRadius: 8,
    },
    scrollbarWidth: 'thin',            // Firefox
    scrollbarColor: '#ccc transparent',
  },
  warning: {
    color: theme.palette.warning.main,
  },
  warningBg: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.warning.main,
    '&:hover': {
      backgroundColor: alpha(theme.palette.warning.main, 0.7),
    },
  },

  customScrollBar: {
    borderRadius: '8px',
    overflowY: 'auto',
    backgroundColor: '#f9f9f9',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    padding: '0px',
    minWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      '-webkit-overflow-scrolling': 'touch', 
      maxWidth: '100vw',
    },
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px',
      [theme.breakpoints.down('sm')]: {
        width: '6px',
        height: '6px',
      },
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      borderRadius: '8px',
      [theme.breakpoints.down('sm')]: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      },
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f9f9f9',
    },
  },
  tagItem: {
    display: 'inline-block',
    margin: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.warning.main, 0.1),
    color: theme.palette.warning.main,
    fontSize: '0.875rem',
    fontWeight: 500,
    textAlign: 'center',
  },
  emptyTagItem: {
    display: 'inline-block',
    margin: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.grey[500], 0.2),
    color: theme.palette.common.black,
    fontSize: '0.875rem',
    fontWeight: 500,
    textAlign: 'center',
  },
  stickyFooter: {
    position: 'sticky',
    bottom: 0,
    backgroundColor: theme.palette.background.paper,
    zIndex: 2,
    '& td': {
      borderTop: `2px solid ${theme.palette.divider}`,
    },
  },
  headerCheckbox: {
    color: theme.palette.common.white,
    '&.Mui-checked': {
      color: theme.palette.common.white,
    },
    '&.MuiCheckbox-indeterminate': {
      color: theme.palette.common.white,
    },
  },
}));
